import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "italic"
}

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import { Initiative } from "@/model";
import { useRoute } from "vue-router";
import Heading from "@/components/Heading.vue";
import { computed } from "vue";
import { ComputedRef } from "@vue/reactivity";
import UrlPreview from "@/components/UrlPreview.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InitiativeView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const slug = route.params.slug;

const initiative: Initiative = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('initiatives').getFirstListItem<Initiative>(`slug = '${slug}'`))),
  __temp = await __temp,
  __restore(),
  __temp
);

const filesToken = (
  ([__temp,__restore] = _withAsyncContext(() => pb.files.getToken())),
  __temp = await __temp,
  __restore(),
  __temp
);

const fileUrls: ComputedRef<{ name: string, url: string, }[]> = computed(() => {
  return initiative.files.map(fileName => ({
    name: fileName,
    url: pb.files.getUrl(initiative, fileName, { token: filesToken }),
  }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, { subtitle: "Initiatives" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(initiative).name), 1)
      ]),
      _: 1
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(initiative).abstract), 1),
        (_unref(initiative).details)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "raw-content",
              innerHTML: _unref(initiative).details
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        _createVNode(Heading, null, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Files")
          ])),
          _: 1,
          __: [0]
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileUrls.value, (file) => {
          return (_openBlock(), _createBlock(UrlPreview, {
            name: file.name,
            url: file.url
          }, null, 8, ["name", "url"]))
        }), 256)),
        (fileUrls.value.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "No files available (for now)"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})